import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, gql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Grid
} from 'react-bootstrap';
import cx from 'classnames';
import s from './Feedback.css';
import cs from '../commonStyle.css';
import getLocalizedContent from '../../core/helpers/getLocalizedContent';


// Image icons
import iconOne from '/public/SiteIcons/supportIconOne.svg';
import iconTwo from '/public/SiteIcons/supportIconTwo.svg';
import iconThree from '/public/SiteIcons/supportIconThree.svg';

class Feedback extends React.Component {

  static propTypes = {
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getFooterSetting: PropTypes.shape({
        title1: PropTypes.string.isRequired,
        content1: PropTypes.string.isRequired,
        title2: PropTypes.string.isRequired,
        content2: PropTypes.string.isRequired,
        title3: PropTypes.string.isRequired,
        content3: PropTypes.string.isRequired,
      })
    }),
  };

  render() {
    const { data: { loading, getFooterSetting }, locale } = this.props;

    if (!loading && getFooterSetting) {
      // Get localized content
      const title1 = getLocalizedContent(getFooterSetting, 'title1', locale);
      const content1 = getLocalizedContent(getFooterSetting, 'content1', locale);
      const title2 = getLocalizedContent(getFooterSetting, 'title2', locale);
      const content2 = getLocalizedContent(getFooterSetting, 'content2', locale);
      const title3 = getLocalizedContent(getFooterSetting, 'title3', locale);
      const content3 = getLocalizedContent(getFooterSetting, 'content3', locale);

      return (
        <div className={s.root}>
          <div className={s.container}>
            <div className={s.feedbackContainer}>
                <Row className={s.feedbackRow}>

                  {
                    <Col
                      xs={12} sm={4} md={4} lg={4}
                      className={cx(s.feedbackBox, s.borderRight, 'borderRightFeedRTL')}>
                      <img src={iconOne} />
                      <div>
                        <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}>{title1}</label>
                        <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal, s.textColor)}>{content1}</label>
                      </div>
                    </Col>
                  }
                  {
                    <Col
                      xs={12} sm={4} md={4} lg={4}
                      className={cx(s.feedbackBox, s.borderRight, 'borderRightFeedRTL')}
                    >
                      <img src={iconTwo} />
                      <div className={cx(s.feedbackContent, 'textAlignRightRTL')}>
                        <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}>{title2}</label>
                        <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal)}>
                          {content2}
                        </label>
                      </div>
                    </Col>
                  }
                  {
                    <Col
                      xs={12} sm={4} md={4} lg={4}
                      className={cx(s.feedbackBox)}
                    >
                      <img src={iconThree} />

                      <div className={cx(s.feedbackContent, 'textAlignRightRTL')}>
                        <label className={cx(cs.commonSubTitleText, cs.paddingTop4, cs.fontWeightBold)}> {title3}</label>
                        <label className={cx(cs.paddingTop2, cs.commonContentText, cs.fontWeightNormal)}>{content3}</label>
                      </div>
                    </Col>
                  }
                </Row>
            </div>
          </div>
        </div>
      );
    } else {
      return <div />
    }
  }
}

const mapState = (state) => ({
  locale: state.intl.locale
});

export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState),
  graphql(gql`
   query getFooterSetting {
    getFooterSetting {
        id
        title1
        title1_en
        title1_fr
        title1_it
        title1_pt
        content1
        content1_en
        content1_fr
        content1_it
        content1_pt
        title2
        title2_en
        title2_fr
        title2_it
        title2_pt
        content2
        content2_en
        content2_fr
        content2_it
        content2_pt
        title3
        title3_en
        title3_fr
        title3_it
        title3_pt
        content3
        content3_en
        content3_fr
        content3_it
        content3_pt
      }
    }
`, { options: { ssr: true } })
)(Feedback);
